// extracted by mini-css-extract-plugin
export var copyableField = "_qc-4";
export var customerBadge = "_qc-0";
export var customerInfoTitle = "_qc-2";
export var details = "_qc-1";
export var dropdownContainer = "_qc-5";
export var dropdownImage = "_qc-6";
export var editAssigneeForm = "_qc-a";
export var editButton = "_qc-3";
export var email = "_qc-7";
export var hidden = "_qc-d";
export var input = "_qc-8";
export var saveButton = "_qc-b";
export var shopifyIcon = "_qc-c";
export var suggestionBadge = "_qc-e";
export var suggestionText = "_qc-f";
export var username = "_qc-9";